import { TPointResponse } from '@project/view-models';
import { TSearchFilterDTO } from '../../filters-advanced/models/advanced-filter.model';
import { ESortOrder } from '../../site/site-table/sort-order-enum';

export type TSearchResponseDTO = {
  pagination: {
    cursor?: {
      pointId: string;
      updatedAt: number;
    };
    pageSize?: number;
  };
  filter?: {
    groupOperator: TSearchAdvancedFilterOperator;
    groups: TSearchFilterSubgroup[];
    criteria: TSearchFilterDTO[];
  };
  data?: string[]; // List of fields to be added to the response
  sort?: {
    keys: string[];
    direction: ESortOrder;
  }[];
};

export type TSearchFilterSubgroup = {
  criteriaOperator?: TSearchAdvancedFilterOperator;
  criteria?: TSearchFilterDTO[];
  subgroups?: TSearchFilterSubgroup[];
};

export enum EPointSearchOperator {
  EQUALS = 'EQ',
  NOT_EQUALS = 'NE',
  LESS_THAN = 'LT',
  LESS_THAN_OR_EQUAL = 'LTE',
  GREATER_THAN = 'GT',
  GREATER_THAN_OR_EQUAL = 'GTE',
  IN = 'IN',
  NOT_IN = 'NIN',
  REGEX = 'REGEX',
  BETWEEN = 'BETWEEN',
  NOT_REGEX = 'NOT_REGEX',
}

export type TSearchAdvancedFilterOperator = 'AND' | 'NAND' | 'OR' | 'NOR';

export type TPointSearchResponse = TSearchResponse<TPointResponse>;

export type TSearchResponse<T> = {
  data: T[];
  nextCursor: {
    pointId: string;
    updatedAt: number;
  };
  hasNext: boolean;
  pageSize: number;
  totalCount: number;
};
